
import Vue from "vue";

export default Vue.component("SHCheckCardSkeleton", {
  components: {
    QSkeleton: () => import("../elements/QSkeleton.vue"),
  },
});
